import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitialStateType {
    requestId: string | undefined;
    datasetId: string | undefined;
}

const initialState: InitialStateType = {
    requestId: undefined,
    datasetId: undefined,
};

const jobscriptEditSlice = createSlice({
    name: 'jobscriptEdit',
    initialState,
    reducers: {
        setJobscriptEdit: (state, action: PayloadAction<InitialStateType>) => {
            const { requestId, datasetId } = action.payload;
            state.datasetId = datasetId;
            state.requestId = requestId;
        },
        resetJobscriptEdit: state => {
            state.requestId = undefined;
            state.datasetId = undefined;
        },
    },
});

export const { setJobscriptEdit, resetJobscriptEdit } = jobscriptEditSlice.actions;
export default jobscriptEditSlice.reducer;
